"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _AnalyticsViewFilters = require("../constants/AnalyticsViewFilters");

var PropertyFilter =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(PropertyFilter, _Record);

  function PropertyFilter() {
    (0, _classCallCheck2.default)(this, PropertyFilter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyFilter).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyFilter, [{
    key: "getValueInputPrefix",
    value: function getValueInputPrefix() {
      var property = this.get('prop');
      var operator = this.get('op');

      if (property === _AnalyticsViewFilters.URL_PATH_AND_QUERY && (operator === _AnalyticsViewFilters.STARTS_WITH || operator === _AnalyticsViewFilters.NOT_STARTS_WITH)) {
        return '/';
      }

      return null;
    }
  }, {
    key: "getValueInputValue",
    value: function getValueInputValue() {
      if (this.shouldShowMultiSelect()) {
        return this.get('args', (0, _immutable.List)()).toJS();
      }

      var value = this.get('args', (0, _immutable.List)()).first() || '';

      if (this.getValueInputPrefix()) {
        return value.replace(this.getValueInputPrefix(), '');
      }

      return value;
    }
  }, {
    key: "shouldShowMultiSelect",
    value: function shouldShowMultiSelect() {
      return [_AnalyticsViewFilters.IS_ANY_OF, _AnalyticsViewFilters.IS_NOT_ANY_OF].includes(this.get('op'));
    }
  }, {
    key: "shouldShowValueInput",
    value: function shouldShowValueInput(operator) {
      return operator === this.get('op') && ![_AnalyticsViewFilters.KNOWN, _AnalyticsViewFilters.NOT_KNOWN].includes(operator);
    }
  }, {
    key: "prependPrefix",
    value: function prependPrefix(value) {
      if (this.getValueInputPrefix() && _immutable.List.isList(value)) {
        return value.map(this.prependPrefix);
      }

      if (this.getValueInputPrefix() && !RegExp("^" + this.getValueInputPrefix()).test()) {
        return "" + this.getValueInputPrefix() + value;
      }

      return value;
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      var newValue = this.prependPrefix(value);

      if (_immutable.List.isList(newValue)) {
        return this.set('args', newValue);
      }

      return this.set('args', _immutable.List.of(newValue));
    }
  }]);
  return PropertyFilter;
}((0, _immutable.Record)({
  args: (0, _immutable.List)(),
  prop: null,
  op: null
}, 'PropertyFilter'));

exports.default = PropertyFilter;
module.exports = exports.default;